import React from 'react';
import logo from '../assets/logo.png';

export default function Watermark() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff',          // white background
        backgroundImage: `url(${logo})`,
        backgroundRepeat: 'repeat',
        backgroundSize: '120px',
        opacity: 0.05,                       // more transparent
        zIndex: -1,
        pointerEvents: 'none'
      }}
    />
  );
}